import React from 'react'
import Link from 'gatsby-link'
import { Button } from 'antd'
import Sidebar from '../global/data/aside'

import V1_Articles from '../global/data/v1'


const RelatedLinks = (props) => {

  if ( props.data.type === 'post' ) { return null; }
  if ( ! props.data.series )  { return null; }

  const aside = Sidebar[ props.data.series ];
  let asideData;

    // depending on the type of aside content, store them in an arry for easier access.
    if ( aside && aside.type === 'sections' ) {
      const arr = [];
      aside.data.map( sections => {
        sections.data.map( page => {
          arr.push(page);
        } )
      });
      asideData = arr;
    } else {
      asideData = aside.data;
    }


  if ( asideData.length < 1 ) { return null; }

  return(
    <div className="related--series">
      <div className="title-container"><p className="title">More in this series</p></div>
      { asideData.map( post => <Link key={ post.url } to={ post.url }>{ post.title }</Link> ) }
    </div>
  )

}


const ArticlesPage = ({ data }) => {

  return (
    <div className="page--articles">

      <h1>Some of the Articles and Tutorials on Frontend and Backend Development written by me.</h1>
      <p>Topics include Node JS, React, Express, GraphQL, MongoDB, Javascript, AI, PWA, Webpack, Business Analytics, Serverless and related.</p>

      <Link to="/archive">
        <Button type="primary" style={{ fontSize: 18 }}>Looking for Older Tutorials or Website?</Button>
      </Link>

      <div className="component--posts-list">
      { data && data.allMarkdownRemark.edges.map( post => (
        <div className="post" key={ post.node.id }>
          <h2><Link to={ post.node.frontmatter.path }>{ post.node.frontmatter.title }</Link></h2>
          <p className="published">{ post.node.frontmatter.date }</p>
          <p>{ post.node.excerpt }</p>
          <RelatedLinks data={ post.node.frontmatter } />
        </div>
      )) }
      </div>

      <hr/>

      <div className="component--posts-list">
      { V1_Articles.map( link => (
        <div className="post" key={ link.url }>
          <h2><a href={ link.url } target="_blank">{ link.title }</a></h2>
          <p className="published">{ link.date }</p>
          <p>{ link.excerpt }</p>
        </div>
      )) }
      </div>


    </div>
  );

}


export default ArticlesPage


export const pageQuery = graphql`
    query IndexQuery {
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: {
          frontmatter: { visible: { eq: true } },
        }
      ) {
        edges {
          node {
            id
            excerpt
            frontmatter {
              title
              path
              type
              series
              date(formatString: "MMMM DD, YYYY [at] hh:mm A")
            }
          }
        }
      }
    }
  `


/*


**This website is powered by [Gatsby JS](https://www.gatsbyjs.org/) and [Firebase](https://firebase.google.com/)**

      <Alert
        message="Looking for Previous Version of Site?"
        description={(<p><span>You can find all the previous articles <Link to="archive">Here (archive)</Link> and you can the website by <a href="https://v1.dhruvkumarjha.com" target="_blank">Clicking Here</a>.</span></p>)}
        type="info"
        showIcon
        banner={true}
        closable
      />



*/



// WEBPACK FOOTER //
// ./src/pages/articles.js